import React, { Fragment } from "react";
import Button from "react-bootstrap/Button";
import SearchAGgrid from "../../SearchAGgrid";
import {
  CustomDropdown,
  SearchInput,
  Chips,
  CustomTableFooter,
  SessionExpiredModal,
  CustomModal,
  CreateStudentModal,
} from "../../components";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import Skeleton from "@mui/material/Skeleton";
import { ApiService } from "../../utils/ApiService";
import { SideBarAddLogo, DownloadTempLogo } from "../../assets/icons";
import { colors } from "../../config/colors";
import { Typography } from "@mui/material";
import {
  API_AUTH_TOKEN,
  API_CONTEXT_TYPE,
  API_METHOD_POST,
} from "../../config/constants";

class StudentManagement extends React.Component {
  constructor(props) {
    super(props);

    this.adminRole = localStorage.getItem("role");
    this.merchantId = "";
    if (
      this.adminRole == ADMIN_TYPE.SUPERADMIN ||
      this.adminRole == ADMIN_TYPE.SALESADMIN
    ) {
      this.merchantId = localStorage.getItem("globalMerchantId");
    } else if (this.adminRole == ADMIN_TYPE.SCHOOLADMIN) {
      this.merchantId = localStorage.getItem("schoolAdminMerchantId");
    }
    this.searchCategoryList = [
      { label: "" },
      { label: "Student ID", value: "studentId" },
      { label: "First Name", value: "firstName" },
      { label: "Last Name", value: "lastName" },
      { headerName: "Given Name", field: "givenName" },
      { label: "Grade", value: "grade" },
      { headerName: "Date Of Birth", field: "dateOfBirth" },
      { label: "Gender", value: "gender" },
      { label: "Division", value: "division" },
      { label: "Parent Id", value: "parentId" },
      { label: "Primary Mobile Number", value: "primaryMobileNum" },
      { label: "Email Id1", value: "emailId1" },
      { label: "Student Registered", value: "studentRegistered" },
    ];

    this.state = {
      pageNo: 0,
      totalPages: 0,
      pageSize: 20,
      studentRecordList: [],
      totalRecordsCount: 0,
      sessionExpired: false,
      searchCategory: null,
      searchText: "",
      searchFilter: [],
      showAddStudent: false,
      updateSuccess: false,
      updateFailure: false,
      addSuccessMsg: "",
      isLoading: false,
      disabledExportButton: false,
      errorMessage: "",
    };
    this.onPageSize = this.onPageSize.bind(this);
    this.onLeftArrow = this.onLeftArrow.bind(this);
    this.onRightArrow = this.onRightArrow.bind(this);
    this.onHideAddStudent = this.onHideAddStudent.bind(this);
    this.sessionExpiredClose = this.sessionExpiredClose.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }
  componentDidMount() {
    this.onFetchCount();
  }

  onFetchCount = async () => {
    try {
      const payload = {
        merchantId: this.merchantId,
        filterList: this.state.searchFilter,
      };
      const respCount = await ApiService.postRequest(
        API_URL.GET_STUDENT_COUNT,
        payload
      );

      let totalCount = 0;
      if (respCount?.status?.code === "Y") totalCount = respCount.body;
      if (totalCount === 0) {
        this.setState({
          isLoading: false,
          studentRecordList: [],
          totalRecordsCount: totalCount,
          totalPages: 0,
        });
        return;
      }
      this.onFetchStudentList(totalCount);
    } catch (err) {
      console.error("Error fetching student count:", err);
    }
  };

  onFetchStudentList = async (totalCount = this.state.totalRecordsCount) => {
    try {
      const payload = {
        merchantId: this.merchantId,
        filterList: this.state.searchFilter,
      };
      const url =
        API_URL.GET_STUDENT_RECORDS +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
      const resp = await ApiService.postRequest(url, payload);
      if (resp?.status?.code === "Y" && resp.body) {
        const totalPages = Math.ceil(totalCount / this.state.pageSize);
        this.setState({
          isLoading: false,
          studentRecordList: resp.body,
          totalRecordsCount: totalCount,
          totalPages: totalPages,
        });
      }
    } catch (err) {
      console.error("Error fetching student list:", err);
      this.setState({ isLoading: false });
    }
  };

  sessionExpiredClose = () => {
    this.setState({ sessionExpired: false });
  };

  onPageSize = (event) => {
    this.setState({ pageSize: event.target.value }, this.onFetchStudentList);
  };

  onLeftArrow = () => {
    this.setState({ pageNo: this.state.pageNo - 1 }, this.onFetchStudentList);
  };

  onRightArrow = () => {
    this.setState({ pageNo: this.state.pageNo + 1 }, this.onFetchStudentList);
  };

  onSearchCategorySelected = (index) => {
    const selectedItem = this.searchCategoryList[index];
    this.setState({ searchCategory: selectedItem });
  };

  onSearch = () => {
    if (this.state.searchText.length === 0) return;
    const newSearchFilter = [...this.state.searchFilter];
    newSearchFilter.push({
      param: this.state.searchCategory.value,
      value: this.state.searchText,
    });
    this.setState(
      {
        searchFilter: newSearchFilter,
        pageNo: 0,
        searchCategory: null,
        searchText: "",
      },
      this.onFetchCount
    );
  };

  onRemoveFilterChip = (label, index) => {
    const newSearchFilter = this.state.searchFilter;
    newSearchFilter.splice(index, 1);
    this.setState(
      {
        searchFilter: newSearchFilter,
        pageNo: 0,
        searchCategory: null,
        searchText: "",
      },
      this.onFetchCount
    );
  };

  onClearFilter = () => {
    this.setState(
      { searchFilter: [], pageNo: 0, searchCategory: null, searchText: "" },
      this.onFetchCount
    );
  };

  handleShowAdd = () => {
    this.setState({ showAddStudent: true });
  };

  onHideAddStudent = () => {
    this.setState({ showAddStudent: false }, this.onFetchCount);
  };

  handleExport = () => {
    let authCode = localStorage.getItem("bearer");
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (roleData === ADMIN_TYPE.SUPERADMIN) {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData === ADMIN_TYPE.SCHOOLADMIN) {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    let data = {
      merchantId: merchantIdGlobal,
      filterList: []
    }
    if (this.state.disabledExportButton) return;
    this.setState({ disabledExportButton: true });
    fetch(API_URL.GET_STUDENT_LIST_EXPORT, {
      method: API_METHOD_POST,
      body: JSON.stringify(data),
      headers: {
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
        'Content-Type': API_CONTEXT_TYPE
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        const now = new Date();
        const timestamp = now
          .toISOString()
          .replace(/[:.]/g, "-")
          .slice(0, 19); // "YYYY-MM-DDTHH-MM-SS"
        const schoolId = merchantIdGlobal || "UnknownSchool";
        a.download = `StudentData_${schoolId}_${timestamp}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => console.error(err)).finally(() => {
        this.setState({ disabledExportButton: false });
      });
  };

  renderHeader() {
    const filterList = this.searchCategoryList.map((item) => item.label);
    return (
      <div className="d-flex flex-row justify-content-between align-items-center m-3">
        {this.state.isLoading ? (
          <Fragment>
            <div className="d-flex flex-row align-items-center gap-4">
              <Skeleton variant="rect" width={200} height={56} />
              <div className="mt-3" />
              <Skeleton variant="rect" width={200} height={56} />
            </div>
            <Skeleton variant="rect" width={100} height={56} />
          </Fragment>
        ) : (
          <Fragment>
            <div className="d-flex flex-row align-items-center gap-4">
              <CustomDropdown
                label="Search By"
                value={this.state?.searchCategory?.label ?? ""}
                width={215}
                items={filterList}
                onChange={this.onSearchCategorySelected}
              />
              <SearchInput
                disabled={!this.state.searchCategory}
                id="message"
                label="Search"
                style={{ width: "200px" }}
                value={this.state.searchText}
                onClickSearch={this.onSearch}
                onChange={(event) =>
                  this.setState({ searchText: event.target.value })
                }
              />
            </div>
            <div className="d-flex flex-row align-items-center gap-2">
              <Button
                className={
                  this.adminRole == ADMIN_TYPE.SALESADMIN
                    ? "primary-button-add-disabled"
                    : "primary-button-add"
                }
                onClick={
                  this.adminRole == ADMIN_TYPE.SALESADMIN
                    ? null
                    : this.handleShowAdd
                }
                disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
              >
                <SideBarAddLogo bgColor={colors.white} />
                Add Student
              </Button>
              <Button
                className={
                  this.adminRole == ADMIN_TYPE.SALESADMIN
                    ? "primary-button-add-disabled"
                    : "primary-button-add"
                }
                onClick={
                  this.adminRole == ADMIN_TYPE.SALESADMIN
                    ? null
                    : this.handleExport
                }
                disabled={this.adminRole == ADMIN_TYPE.SALESADMIN || this.state.disabledExportButton}
              >
                <DownloadTempLogo bgColor={colors.white} />
                Export
              </Button>
            </div>
          </Fragment>
        )}
      </div>
    );
  }

  renderFilters() {
    if (this.state.isLoading || this.state.searchFilter.length === 0)
      return null;
    return (
      <div className="d-flex flex-row justify-content-between align-items-center m-3 mt-0">
        <div className="d-flex flex-row align-items-center gap-2">
          <Typography
            variant="h4"
            component="label"
            sx={{ color: colors.nonActive, marginRight: 8 }}
          >
            Filtered by
          </Typography>
          <div className="d-flex flex-wrap gap-2">
            {this.state.searchFilter.map((filter, idx) => (
              <Chips
                index={idx}
                key={filter.param + filter.value}
                label={`${filter.param}: ${filter.value}`}
                onClose={this.onRemoveFilterChip}
              />
            ))}
          </div>
        </div>
        <Typography
          variant="h4"
          component="button"
          onClick={this.onClearFilter}
          className="clear-filter"
        >
          Clear Filters
        </Typography>
      </div>
    );
  }

  renderFooter() {
    return (
      <div style={{ margin: 24, marginTop: 32 }}>
        {this.state.isLoading ? (
          <div className="d-flex flex-row justify-content-center align-items-end">
            <Skeleton variant="rect" width={100} height={56} />
            <Skeleton variant="rect" width={100} height={56} />
          </div>
        ) : (
          <CustomTableFooter
            pageNo={this.state.pageNo}
            pageSize={this.state.pageSize}
            totalCount={this.state.totalRecordsCount}
            onPageSizeChanged={this.onPageSize}
            onLeftArrow={this.onLeftArrow}
            onRightArrow={this.onRightArrow}
          />
        )}
      </div>
    );
  }

  renderAddStudentModal() {
    return (
      <CreateStudentModal
        show={this.state.showAddStudent}
        handleHide={this.onHideAddStudent}
      />
    );
  }

  render() {
    return (
      <Fragment>
        <div>
          {this.renderHeader()}
          {this.renderFilters()}
          <SearchAGgrid
            studentDetails={this.state.studentRecordList}
            isLoading={this.state.isLoading}
            funcGetList={this.onFetchStudentList}
          />
          {this.renderFooter()}
        </div>
        {this.renderAddStudentModal()}
        {this.state.sessionExpired ? (
          <SessionExpiredModal
            show={this.state.sessionExpired}
            onHide={this.sessionExpiredClose}
          />
        ) : null}
        {this.state.updateSuccess ? (
          <CustomModal
            show={this.state.updateSuccess}
            onHide={() => this.setState({ updateSuccess: false })}
            title={this.state.addSuccessMsg}
            message={""}
          />
        ) : null}
        {this.state.updateFailure ? (
          <CustomModal
            show={this.state.updateFailure}
            onHide={() => this.setState({ updateFailure: false })}
            title={this.state.errorMessage}
            message={""}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default StudentManagement;
